export default __webpack_public_path__ + "static/the-weather-company-440b34502ec30247d4b5119267b8051a.png";